<template>
  <div class="container material">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>实体资料</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">实体资料</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="handleToCategory">分类管理</el-button>
          <el-button class="button"
                     type="primary"
                     @click="handleMaterialCreate">新建资料</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="资料名称"
                      prop="name">
          <el-input v-model="query.name"
                    placeholder="输入资料名称"
                    @input="fetchMaterialList(true)"></el-input>
        </el-form-item>
        <el-form-item label="分类"
                      prop="category_id">
          <el-select v-model="query.category_id"
                     placeholder="请选择"
                     @change="fetchMaterialList(true)"
                     clearable>
            <el-option v-for="item in categorys"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="fetchMaterialList(true)"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="学长搜索"
                      prop="name">
          <el-input v-model="query.author"
                    placeholder="输入学长手机号，真实姓名"
                    @input="fetchMaterialList(true)"
                    style="width:300px;"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="创建人">
          <el-select v-model="query.creator"
                     placeholder="请选择"
                     @change="fetchMaterialList(true)"
                     clearable>
            <el-option v-for="item in $store.state.adminList"
                       :key="item.id"
                       :label="item.nickname"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">资料列表</h3>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="query.status"
                            @change="fetchMaterialList(true)">
              <el-radio-button v-for="(item, index) in filter.status"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="tabs">
        <el-tabs v-model="tabName"
                 @tab-click="handleTabChange">
          <el-tab-pane label="全部商品"
                       name="all"></el-tab-pane>
          <el-tab-pane label="学长商品"
                       name="senior"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="values">
        <!--  <MaterialCard class="material-item" :content="item" :noUp="index == 0" :noDown="index == results.length-1" @remove="handleMaterialRemove" @sort="handleSortChange" v-for="(item, index) in results" :key="item.id"/> -->
        <el-table :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           width="80px"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column prop="id"
                           label="商品图"
                           width="120px"
                           align="center">
            <template slot-scope="scope">
              <el-image style="height: 50px"
                        :src="scope.row.picture_url"
                        fit="fill"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           width="300"
                           label="商品名称"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           width="120"
                           label="资料分类"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateCategory_ids(scope.row.category_ids) }}
            </template>
          </el-table-column>
          <el-table-column prop="service"
                           label="服务描述"
                           width="200"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.service }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="price"
                           label="售价"
                           align="center"
                           width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.price > 0">{{
                scope.row.price + "元"
              }}</span>
              <span v-else>免费</span>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="market_price" label="划线价" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.market_price + "元" }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="user_count"
                           label="销量"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="goCheckOrder(scope.row)">{{ scope.row.user_count - scope.row.virtual_count }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="截止日期"
                           width="170"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.expire_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           width="130"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否配送"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.is_deliver == 1 ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="small"
                      :type="scope.row.status == 1 ? 'success' : 'danger'">{{ scope.row.status == 1 ? "上架" : "下架" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sort"
                           label="排序值"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column label="学长"
                           width="180"
                           align="center"
                           v-if="query.is_author==1"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.author">{{ scope.row.author.realname }}/{{scope.row.author.mobile }}</span></template>
          </el-table-column>
          <el-table-column prop="name"
                           width="120"
                           label="创建人"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="200"
                           align="center"
                           v-if="isfixed">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="goDetail(scope.row)">编辑</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToPreview(scope.row)">浏览</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToClone(scope.row.id)">克隆</el-link>
              <el-link type="danger
            "
                       @click="handleMaterialRemove(scope.row.id)"
                       :underline="false">删除</el-link>
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom:6px;"><span @click="goDetail(scope.row)"
                          style="font-size:16px;color: #409EFF;">
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item command="b"
                                    style="margin-bottom:6px;"><span @click="handleToPreview(scope.row)"
                          style="font-size:16px;color: #409EFF;">
                      浏览
                    </span></el-dropdown-item>
                  <el-dropdown-item command="c"
                                    style="margin-bottom:6px;"><span @click="handleToClone(scope.row.id)"
                          style="font-size:16px;color: #409EFF;">
                      复制
                    </span></el-dropdown-item>
                  <el-dropdown-item command="d"
                                    style="margin-bottom:6px;"><span @click="handleMaterialRemove(scope.row.id)"
                          style="font-size:16px;color: #F56C6C;">
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialCard from '@/components/card/Material'
import {
  materialList,
  materialDestroy,
  materialsUpdate,
  materialClone,
  materialcategorylist,
} from '@/api/material'

export default {
  components: {
    MaterialCard,
  },
  data() {
    return {
      createDialog: false,
      query: {
        name: '',
        author: '',
        startTime: '',
        endTime: '',
        subject: '',
        status: '1',
        sort: '1',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      createDatetime: '',
      pageTotal: 10,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '上架', value: '1' },
          { label: '下架', value: '0' },
        ],
        sorts: [
          { label: '最新', value: '1' },
          { label: '最热', value: '2' },
        ],
      },
      results: [],
      categorys: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      tabName: '',
    }
  },
  created() {
    this.parseQuery()
    this.fetchMaterialList()
    this.fetchCategoryList()
    this.$store.dispatch('getAdminList')
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf()
        this.query.endTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
  },
  methods: {
    // 资料列表请求
    fetchMaterialList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      materialList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 资料分类列表请求
    fetchCategoryList() {
      materialcategorylist({ status: 1, isPaging: 0 }).then((res) => {
        let list = res.list || []
        list.unshift({ id: '', name: '全部' })
        this.categorys = list
      })
    },
    // 检索条件变化
    handleFilterChange(value, type) {
      if (type === 'sort') {
        this.query.sort = value
      }
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchMaterialList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchMaterialList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchMaterialList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      // 手动处理
      this.createDatetime = null
      setTimeout(() => {
        this.fetchMaterialList()
      }, 20)
    },
    // 分类管理
    handleToCategory() {
      this.$router.push(`/material/category`)
    },
    // 资料创建
    handleMaterialCreate() {
      this.$router.push(`/material/create`)
    },
    // 排序位置变化
    handleSortChange(row, type) {
      const list = this.results
      const index = list.findIndex((v) => v.id == row.id)
      list.splice(index, 1)
      if (type == 'up') {
        list.splice(index - 1, 0, row)
      } else if (type == 'down') {
        list.splice(index + 1, 0, row)
      }
      const rows = list.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      materialsUpdate(rows)
        .then((res) => {})
        .catch((error) => {
          this.$message.error('排序更新异常')
          console.log('error: ', error)
        })
    },
    // 资料删除
    handleMaterialRemove(materialId) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          materialDestroy({ id: materialId }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchMaterialList()
          })
        })
        .catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ]
      }
      this.tabName = this.query.is_author == 1 ? 'senior' : 'all'
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    // 表格操作跳转页面
    goDetail(item) {
      if (location.host.includes('admin.kaoyanbox.com')) {
        window.open(`https://admin.kaoyanbox.com/material/edit/${item.id}`)
      } else {
        this.$router.push(`/material/edit/${item.id}`)
      }
    },
    // 预览
    handleToPreview(item) {
      if (item) {
        if (location.host.includes('admin.kaoyanbox.com')) {
          window.open(`https://h5.kaoyanbox.com/material/detail/${item.id}`)
        } else {
          window.open(`http://h5.kaoyanbox.net/material/detail/${item.id}`)
        }
      }
    },
    handleToClone(id) {
      // 二次确认
      this.$confirm('确定要复制吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          materialClone({ id: id }).then((res) => {
            this.$message.success(`复制成功，请在下架列表中查看`)
            this.fetchMaterialList()
          })
        })
        .catch(() => {})
    },
    // 根据销量跳转到订单页面
    goCheckOrder(item) {
      this.$router.push(
        `/order/list?status=1,2,3,4&pay_type=&pageIndex=1&pageSize=10&isPaging=1&goods_name=${item.name}`
      )
    },
    formateCategory_id(id) {
      if (id) {
        return this.categorys.find((v) => {
          return v.id == id
        }).name
      } else {
        return '无'
      }
    },
    formateCategory_ids(ids) {
      if (!ids) {
        return '无'
      }

      // 将字符串分割成数组，过滤掉空值
      const idArray = String(ids)
        .split(',')
        .filter((id) => id.trim() !== '')

      if (idArray.length === 0) {
        return '无'
      }

      // 遍历每个ID，找到对应的名称
      const names = idArray
        .map((id) => {
          const found = this.categorys.find(
            (v) => String(v.id) === String(id).trim()
          )
          return found ? found.name : null
        })
        .filter((name) => name !== null) // 过滤掉未找到的分类

      // 如果所有分类都未找到，返回'无'
      if (names.length === 0) {
        return '无'
      }

      // 用逗号连接所有名称
      return names.join('、')
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (
            this.$store.state.adminList.findIndex((v) => {
              return v.id == val
            }) > -1
          ) {
            return this.$store.state.adminList.find((v) => {
              return v.id == val
            }).nickname
          } else {
            return '无'
          }
        } else {
          return '无'
        }
      }
    },
    handleTabChange(tab) {
      if (tab.name == 'senior') {
        this.query.is_author = 1
      } else {
        this.query.is_author = 0
      }
      this.fetchMaterialList(true)
    },
  },
}
</script>

<style scoped lang="less">
.material {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 101%;
    height: 40px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      width: 100%;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;
    padding-right: 35px;
    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .material-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    .el-link {
      margin: 0 8px;
    }
    .item-table-column {
      text-align: left;
    }
  }
}
</style>
